// Single source of truth for the two bases the document-review experience is
// mounted under: the operator console at /tools/document-review and the
// consultant page at /ai-extracted. Imported by SideBarLayout (nav + active
// state), useDocReviewBase (base detection), and the upload flow so the paths
// can't drift between them.
export const AI_EXTRACTED_ROUTE = '/ai-extracted' as const;
export const DOCUMENT_REVIEW_ROUTE = '/tools/document-review' as const;
